import React from 'react';
import styles from './Login.module.scss'
import AuthForm from 'components/AuthForm/AuthForm';
import { useNavigate } from 'react-router-dom';
import LogoIcon from '../../../icons/LogoIcon'

const LoginContainer = () => {
  const navigate = useNavigate();
  
  const onLoginOk = () => {
    navigate("/");
  }

  return (
    <div className={styles.root}>
      <div className={styles.poweredBy}>
        Powered by MSL
      </div>
      <div className={styles.container}>
        <div className={styles.formWrapper}>
          <div className={styles.companyLogo}>
            <LogoIcon id="login" className={styles.logo}/>
          </div>
          <div className={styles.authFormWrapper}>
            <div className={styles.formTitle}>
              LIS Login
            </div>
            <AuthForm
              onLoginOk={onLoginOk}
            />
          </div>
        </div>
      </div>
    </div>
  );

}

export default LoginContainer;